
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7EwjJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c8fbd77e3788677f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $c8fbd77e3788677f$export$2e2bcd8739ae039 = {
    'fabric.editor.chromeCollapsedPlaceholder': "\u8F38\u5165\u4E00\u4E9B\u5167\u5BB9...",
    'fabric.editor.editorAssistiveLabel': "\u4E3B\u8981\u5167\u5BB9\u5340\u57DF\uFF0C\u6253\u5B57\u5373\u53EF\u8F38\u5165\u6587\u5B57\u3002",
    'fabric.editor.headingLink.toolbarHelpTitle': "\u958B\u555F\u8AAA\u660E\u5C0D\u8A71\u65B9\u584A"
};

});


//# sourceMappingURL=zh_TW.47f3fa9f.js.map
